// // src/views/kiddo-games/letters/components/LetterButton.tsx
import React from 'react';

interface LetterButtonProps {
  letter: string;
  isPlaced: boolean;
  isWrong: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const LetterButton: React.FC<LetterButtonProps> = ({
  letter,
  isPlaced,
  isWrong,
  onClick,
}) => {
  const className = `letter-button${isPlaced ? ' letter-button--placed' : ''}${
    isWrong ? ' letter-button--wrong' : ''
  }`;

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={isPlaced}
      type="button"
    >
      {letter}
    </button>
  );
};
